// Debounce a changing value. The displayed input stays synchronous; only the
// downstream value (filter, search, fetch) lags by `delayMs` (~300-400 ms per
// the UI/UX standard).
import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
